let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("64v3H")).then(() => parcelRequire('3wXGb'));